import numeral from "numeral";
import _ from "lodash";
import { ConversionFormula, CurrencyFormat } from "../models/constants";

export const tryParseFloat = v => {
  const _float = parseFloat(v);
  return isNaN(_float) ? null : _float;
};

export const tryParseInt = v => {
  const _int = parseInt(v);
  return isNaN(_int) ? null : _int;
};

export const distribution = (originalCurrency, localCurrency) => {
  return originalCurrency / localCurrency;
};

export const convertFromMarketFx = (
  amount,
  conversionRate,
  conversionFormula
) => {
  if (
    conversionFormula.toLowerCase() ===
    ConversionFormula.MultiplicationValue.toLowerCase()
  ) {
    return amount / conversionRate;
  }
  return amount * conversionRate;
};

export const toHoursAndMinutes = totalMinutes => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return { hours, minutes };
};

export const currencyFormat = (currencyCode, currencyValue) => {
  const ccyFormat = CurrencyFormat.find(val => val.Currency === currencyCode);

  if (ccyFormat) {
    if (ccyFormat.DecimalPoint === 0) {
      return numeral(Math.ceil(currencyValue)).format(ccyFormat.Format);
    }

    return numeral(_.round(currencyValue, ccyFormat.DecimalPoint)).format(
      ccyFormat.Format
    );
  }

  return numeral(_.round(currencyValue, 2)).format(0, 0.0);
};

export const calculateDropOffDate = date => {
  const combinedDateTime = new Date(`${date.date}T${date.time}:00`);
  const pickUpDate = new Date(combinedDateTime);
  const dropOffDate = new Date(combinedDateTime);
  const duration = date.durationInHour * 60;
  dropOffDate.setMinutes(dropOffDate.getMinutes() + duration);

  const resPickUpDate = {
    year: pickUpDate.getFullYear(),
    month: pickUpDate.getMonth() + 1,
    day: pickUpDate.getDate(),
    hour: pickUpDate.getHours(),
    minute: pickUpDate.getMinutes()
  };

  const resDropOffDate = {
    year: dropOffDate.getFullYear(),
    month: dropOffDate.getMonth() + 1,
    day: dropOffDate.getDate(),
    hour: dropOffDate.getHours(),
    minute: dropOffDate.getMinutes()
  };
  return { pickUp: resPickUpDate, dropOff: resDropOffDate };
};

export const convertDateTime = inputDate => {
  const dateParts = inputDate.date.split("-");
  const timeParts = inputDate.time.split(":");

  const outputDate = {
    year: parseInt(dateParts[0], 10),
    month: parseInt(dateParts[1], 10),
    day: parseInt(dateParts[2], 10),
    hour: parseInt(timeParts[0], 10),
    minute: parseInt(timeParts[1], 10),
    second: 0
  };

  return outputDate;
};

export const extractTextAfterGMT = dateString => {
  const startIndex = dateString.indexOf("GMT") + 3;
  return Number(dateString.slice(startIndex).trim());
};



// WEBPACK FOOTER //
// ./src/helpers/numberHelper.js